import GuidanceProductView from 'text!../views/guidance-product.html';
import GuidanceProductCtrl from '../controllers/GuidanceProductCtrl';

export default (function (RootStates) {
    var parentState = RootStates.quote_bind;

    return {
        guidanceProduct: {
            parent: parentState,
            url: '/guidanceproduct',
            controller: GuidanceProductCtrl,
            template: GuidanceProductView,
            data: {
                trackingUrl: '/guidance/common'
            }
        }
    };
});


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/guidance/common/config/RouteConfig.js
// module id = 956
// module chunks = 0